import React from "react";
import { Table, Button, Space, Popconfirm, Tag, Tooltip } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import PermissionRender from "../../components/PermissionRender";

const PermissionTable = ({
  permissions,
  loading,
  resourceColors,
  actionColors,
  resources,
  actions,
  showModal,
  handleDelete,
}) => {
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "8%",
    },
    {
      title: "Resource",
      dataIndex: "resource",
      key: "resource",
      width: "25%",
      render: (resource) => (
        <Tag
          color={resourceColors[resource]}
          className="px-3 py-1 text-sm font-medium"
        >
          {resource}
        </Tag>
      ),
      filters: resources.map((r) => ({ text: r, value: r })),
      onFilter: (value, record) => record.resource === value,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "25%",
      render: (action) => (
        <Tag
          color={actionColors[action]}
          className="px-3 py-1 text-sm font-medium"
        >
          {action}
        </Tag>
      ),
      filters: actions.map((a) => ({ text: a, value: a })),
      onFilter: (value, record) => record.action === value,
    },
    {
      title: "Combined Permission",
      key: "combined",
      render: (_, record) => (
        <div className="bg-gray-100 px-3 py-1 rounded-md font-mono text-sm">
          {record.resource}.{record.action}
        </div>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: "15%",
      render: (_, record) => (
        <Space>
          <PermissionRender requiredPermission={["permission", "update"]}>
            <Tooltip title="Edit Permission">
              <Button
                type="primary"
                icon={<EditOutlined />}
                size="small"
                onClick={() => showModal(record)}
                className="bg-blue-600"
              />
            </Tooltip>
          </PermissionRender>
          <PermissionRender requiredPermission={["permission", "delete"]}>
            <Popconfirm
              title="Are you sure you want to delete this permission?"
              icon={<ExclamationCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => handleDelete(record.id)}
              okText="Yes"
              cancelText="No"
            >
              <Button
                type="primary"
                danger
                icon={<DeleteOutlined />}
                size="small"
              />
            </Popconfirm>
          </PermissionRender>
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={permissions}
      rowKey="id"
      loading={loading}
      pagination={{
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: (total) => `Total: ${total} permissions`,
      }}
      className="bg-white rounded-lg"
    />
  );
};

export default PermissionTable;
